exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".homework[data-v-d1fe9102]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;align-items:center;width:100%}.homework h3[data-v-d1fe9102]{margin:0}", ""]);

// exports
